import { all } from 'redux-saga/effects'
import watchCandidateFiltersSaga from './candidateFilters'
import watchImpressionsSaga from './impressions'
import watchPositionsSaga from './positions'
import watchStickyFiltersSaga from './stickyFilters'
import watchLastViewedCandidateSaga from '@/CandidateListES/sagas/lastViewedCandidate'
import notificationsSaga from './notifications'

export default function* rootSaga() {
  yield all([
    watchCandidateFiltersSaga(),
    watchImpressionsSaga(),
    watchPositionsSaga(),
    watchStickyFiltersSaga(),
    watchLastViewedCandidateSaga(),
    notificationsSaga(),
  ])
}
